import React, { useState } from 'react'
import { toast } from 'react-toastify';
import { Create_Api } from '../API_URL';
import { motion } from 'framer-motion'

function Subscription() {

    const [Name, setName] = useState('');
    const [Email, setEmail] = useState('');
    const [CompanyName, setCompanyName] = useState('');
    const [Designation, setDesignation] = useState('');


    const [isUploading, setIsUploading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!Name) return toast.error('Name is required')
        if (!Email) return toast.error('Email is required');

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(Email)) {
            return toast.error('Please enter a valid email address');
        }
        if (!CompanyName) return toast.error('Company Name is required')
        if (!Designation) return toast.error('Designation is required')
        setIsUploading(true);

        try {
            const data = {
                Name,
                Email,
                CompanyName,
                Designation
            };

            const response = await Create_Api("api/admin/AddSubscription", data);
            toast.success(response?.message || "Subscription added successfully.");
            setName('');
            setEmail('')
            setCompanyName('')
            setDesignation('')
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            toast.error(error?.response?.data?.message || "Error creating Category.");
            console.error("Error creating Category:", error);
        } finally {
            setIsUploading(false);
        }
    };


    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-white px-4 sm:px-6 lg:px-8 py-10 mt-10">
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="w-full max-w-lg sm:max-w-xl md:max-w-2xl bg-white rounded-2xl shadow-xl p-5 sm:p-6 md:p-10"
            >
                <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-800 mb-2 text-center">
                    DOT Weekly Subscription
                </h2>

                <p className="text-gray-500 mb-6 text-sm sm:text-base text-center">
                    Join our weekly brief from the corridor.
                </p>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <input
                            value={Name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Your Name"
                            className="input"
                        />
                        <input
                            value={Email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Your Email"
                            className="input"
                        />
                    </div>

                    <input
                        value={CompanyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                        placeholder="Company Name"
                        className="input"
                    />

                    <input
                        value={Designation}
                        onChange={(e) => setDesignation(e.target.value)}
                        placeholder="Your Designation"
                        className="input"
                    />

                    <button
                        type="submit"
                        disabled={isUploading}
                        className="w-full bg-[#BB872A] hover:bg-[#a37422] text-white py-3 rounded-lg font-medium transition duration-300 text-sm sm:text-base"
                    >
                        {isUploading ? 'Sending...' : 'Subscribe'}
                    </button>
                </form>
            </motion.div>

            <style jsx>{`
    .input {
      width: 100%;
      padding: 12px 14px;
      border: 1px solid #e5e7eb;
      border-radius: 10px;
      font-size: 14px;
      outline: none;
      transition: all 0.2s ease;
    }

    @media (min-width: 640px) {
      .input {
        font-size: 15px;
        padding: 13px 15px;
      }
    }

    @media (min-width: 1024px) {
      .input {
        font-size: 16px;
        padding: 14px 16px;
      }
    }

    .input:focus {
      border-color: #BB872A;
      box-shadow: 0 0 0 2px rgba(187, 135, 42, 0.15);
    }
  `}</style>
        </div>

    )
}

export default Subscription